// extracted by extract-css-chunks-webpack-plugin
module.exports = {"close":"close","card":"card","close-card":"close-card","modal":"modal","close-modal":"close-modal","modal-container":"modal-container"};